export type LanguageId =
  | "en"
  | "da-DK"
  | "de-CH"
  | "de-DE"
  | "en-GB"
  | "en-US"
  | "es-ES"
  | "fr-FR"
  | "it-IT"
  | "nl-NL"
  | "no-NO"
  | "pt-PT"
  | "sv-SE"
  | "nl-BE"
  | "fr-BE"
  | "fr-CH"
  | "it-CH"
  | "zh-Hant"
  | "en-AU"
  | "zh-CN"
  | "ja-JP"
  | "ko-KR"
  | "en-NZ"
  | "en-CA"
  | "fr-CA"
  | "zh-TW"
  | "en-SG"
  | "en-HK"
  | "en-GL";

export interface Country {
  img: string;
  label: string;
  id: LanguageId;
  countryCode?: string;
}

export const countries: { [key: string]: Country[] } = {
  "North America": [
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/ca.svg",
      label: "Canada (EN)",
      id: "en-CA",
      countryCode: "CA",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/ca.svg",
      label: "Canada (FR)",
      id: "fr-CA",
      countryCode: "CA",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/us.svg",
      label: "United States",
      id: "en-US",
      countryCode: "US",
    },
  ],
  Europe: [
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/be.svg",
      label: "België (NL)",
      id: "nl-BE",
      countryCode: "BE",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/be.svg",
      label: "Belgique (FR)",
      id: "fr-BE",
      countryCode: "BE",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/ch.svg",
      label: "Schweiz (DE)",
      id: "de-CH",
      countryCode: "CH",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/ch.svg",
      label: "Suisse (FR)",
      id: "fr-CH",
      countryCode: "CH",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/ch.svg",
      label: "Svizzera (IT)",
      id: "it-CH",
      countryCode: "CH",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/de.svg",
      label: "Deutschland",
      id: "de-DE",
      countryCode: "DE",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/dk.svg",
      label: "Danmark",
      id: "da-DK",
      countryCode: "DK",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/es.svg",
      label: "España",
      id: "es-ES",
      countryCode: "ES",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/fr.svg",
      label: "France",
      id: "fr-FR",
      countryCode: "FR",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/gb.svg",
      label: "United Kingdom",
      id: "en-GB",
      countryCode: "UK",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/it.svg",
      label: "Italia",
      id: "it-IT",
      countryCode: "IT",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/nl.svg",
      label: "Nederland",
      id: "nl-NL",
      countryCode: "NL",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/no.svg",
      label: "Norge",
      id: "no-NO",
      countryCode: "NO",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/se.svg",
      label: "Sverige",
      id: "sv-SE",
      countryCode: "SE",
    },
    {
      img: "https://www.svgrepo.com/show/98597/global.svg",
      label: "Other",
      // Below 2 dummy values are assigned to handle hide show functionalities for EMEA countries.
      id: "en-GL",
      countryCode: "GL",
    },
  ],
  "Asia Pacific": [
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/au.svg",
      label: "Australia",
      id: "en-AU",
      countryCode: "AU",
    },
    // {
    // 	img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/cn.svg",
    // 	label: "中国",
    // 	id: "zh-CN",
    // 	countryCode: "CN"
    // },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/jp.svg",
      label: "日本",
      id: "ja-JP",
      countryCode: "JP",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/kr.svg",
      label: "대한민국",
      id: "ko-KR",
      countryCode: "KR",
    },
    {
      img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/nz.svg",
      label: "New Zealand",
      id: "en-NZ",
      countryCode: "NZ",
    },
    {
      img: "https://cdn.jsdelivr.net/npm/flag-icons@7.5.0/flags/1x1/tw.svg",
      label: "Taiwan",
      id: "zh-TW",
      countryCode: "TW",
    },
    {
      img: "https://cdn.jsdelivr.net/npm/flag-icons@7.5.0/flags/1x1/sg.svg",
      label: "Singapore",
      id: "en-SG",
      countryCode: "SG",
    },
    {
      img: "https://cdn.jsdelivr.net/npm/flag-icons@7.5.0/flags/1x1/hk.svg",
      label: "Hong Kong",
      id: "en-HK",
      countryCode: "HK",
    },
    {
      // img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/cn.svg",
      img: "https://www.svgrepo.com/show/98597/global.svg",
      label: "中文（繁體)",
      id: "zh-Hant",
      countryCode: "Hant",
    },
  ],
  // Others: [
  // {
  // 	img: "https://www.svgrepo.com/show/98597/global.svg",
  // 	label: "Global",
  // 	id: "en",
  // },
  // ],
};

const fallbackMap: Record<string, string> = {
  sv: "sv-SE",
  en: "en-US",
  fr: "fr-FR",
  "fr-BE": "fr-FR",
  de: "de-DE",
  it: "it-IT",
  es: "es-ES",
  nl: "nl-NL",
  no: "no-NO",
  pt: "pt-PT",
  zh: "zh-CN",
  ja: "ja-JP",
  ko: "ko-KR",
  da: "da-DK",
};
export const fallbackLanguage: Country = {
  img: "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/us.svg",
  label: "United States",
  id: "en-US",
};

export const alternateProductLinks = [
  {
    countryId: "en-US",
    switchControlLinks: [
      {
        label: "How to Use SwitchControl in Latched Mode",
        link: "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DhCv3bsVUoJY%26list%3DPLKg9DdBudRRSiiNbcTaIuIg1Oe8Nrr7sp%26t%3D20s&data=05%7C02%7CSaidivya.Gogineni%40permobil.com%7C4df7ee3644074e2997f508de01da98af%7C5115291ba69f498daa1170c0574d7df0%7C0%7C0%7C638950235559147353%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=V4pRb%2BET7HynvkHru4Qe9ILe1AUcHfEmMjTm6iCsWi0%3D&reserved=0",
      },
      {
        label: "How to Use SwitchControl in Momentary Mode",
        link: "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DdtdUXXYMU-8%26list%3DPLKg9DdBudRRSiiNbcTaIuIg1Oe8Nrr7sp&data=05%7C02%7CSaidivya.Gogineni%40permobil.com%7C4df7ee3644074e2997f508de01da98af%7C5115291ba69f498daa1170c0574d7df0%7C0%7C0%7C638950235559164866%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=QhvDRSAZc%2Frme8uCpZgSZeZILOw6f1y2MvgP7ONFNJM%3D&reserved=0",
      },
    ],
    buddyButtonLinks: [
      {
        label: "How to use Buddy Button",
        link: "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3Dn5uHhB2hsfs%26t%3D4s&data=05%7C02%7CSaidivya.Gogineni%40permobil.com%7C4df7ee3644074e2997f508de01da98af%7C5115291ba69f498daa1170c0574d7df0%7C0%7C0%7C638950235559114767%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=Tn76qc6M9vLkucxG9t%2FckEK%2F0xh7osgSjCxtHL7Rl9Y%3D&reserved=0",
      },
    ],
  },
  {
    countryId: "en-CA",
    switchControlLinks: [
      {
        label: "How to Use SwitchControl in Latched Mode",
        link: "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DhCv3bsVUoJY%26list%3DPLKg9DdBudRRSiiNbcTaIuIg1Oe8Nrr7sp%26t%3D20s&data=05%7C02%7CSaidivya.Gogineni%40permobil.com%7C4df7ee3644074e2997f508de01da98af%7C5115291ba69f498daa1170c0574d7df0%7C0%7C0%7C638950235559147353%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=V4pRb%2BET7HynvkHru4Qe9ILe1AUcHfEmMjTm6iCsWi0%3D&reserved=0",
      },
      {
        label: "How to Use SwitchControl in Momentary Mode",
        link: "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DdtdUXXYMU-8%26list%3DPLKg9DdBudRRSiiNbcTaIuIg1Oe8Nrr7sp&data=05%7C02%7CSaidivya.Gogineni%40permobil.com%7C4df7ee3644074e2997f508de01da98af%7C5115291ba69f498daa1170c0574d7df0%7C0%7C0%7C638950235559164866%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=QhvDRSAZc%2Frme8uCpZgSZeZILOw6f1y2MvgP7ONFNJM%3D&reserved=0",
      },
    ],
    buddyButtonLinks: [
      {
        label: "How to use Buddy Button",
        link: "https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3Dn5uHhB2hsfs%26t%3D4s&data=05%7C02%7CSaidivya.Gogineni%40permobil.com%7C4df7ee3644074e2997f508de01da98af%7C5115291ba69f498daa1170c0574d7df0%7C0%7C0%7C638950235559114767%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=Tn76qc6M9vLkucxG9t%2FckEK%2F0xh7osgSjCxtHL7Rl9Y%3D&reserved=0",
      },
    ],
  },
  {
    countryId: "fr-CA",
    switchControlLinks: [
      {
        label: "How to use SwitchControl",
        link: "https://www.permobil.com/fr-ca/produits/assistance-electrique/smartdrive-switchcontrol",
      },
    ],
    buddyButtonLinks: [
      {
        label: "How to use Buddy Button",
        link: "https://www.permobil.com/fr-ca/produits/assistance-electrique/smartdrive-switchcontrol",
      },
    ],
  },
];

const supported = Object.values(countries).flat();
const getCountryForLanguageId = (lang: string) => {
  return supported.find((country) => country.id === lang);
};

export const getInitialLanguage = (lang: string): Country =>
  getCountryForLanguageId(fallbackMap[lang] || lang) || fallbackLanguage;

export const getSupportedLanguages = (): Country[] => supported;
